const AdminDashboard = () => {
  // Supprimer la fonction de déconnexion car elle est gérée par le Header du dashboard

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold">Dashboard Administrateur</h1>
      <p className="mt-4">Bienvenue sur votre espace administrateur.</p>
      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-xl font-semibold mb-4">
            Gestion des utilisateurs
          </h2>
          <p>Gérez les utilisateurs de la plateforme</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-xl font-semibold mb-4">Statistiques</h2>
          <p>Consultez les statistiques de la plateforme</p>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
